import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { PageNavBar } from '../../cmps/nav-header/page-nav-bar'

export const DatabasePage: React.FC = () => {
  const location = useLocation()

  if (location.pathname === '/database') {
    return <Navigate to="/database/objectives" replace />
  }

  return <section className="database-page page-content-padding">
    <PageNavBar mainPage='database' />
    <Outlet />
  </section>
}